<template>
    <div class="w-100 stepAreaMain">
        <!-- step 1 -->
        <div class="stepArea middleBox">
            <div class="whiteBG Step-Form">
                <!--loader - message--->
                <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
                <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
                <!--------------------------individual------------------------------->
                <div class="stepForm row">
                    <h3 class="mb-4 pb-1 w-100 text-center f-26">{{ $t("fxpersonalInfo") }}</h3>
                    <div class="col-12 col-md-12 mobPad">
                        <h3 class="greenlable mb-3">{{ $t("fxDateofBirth") }}</h3>
                        <div class="dobRow d-flex align-items-start mb-3">
                            <div class="form-group field-wrapper m-0 active">
                                <label class="Date_Birth">{{ $t("fxDOB") }} <sup class="red">*</sup></label>
                                <input class="customflaotField mdb-select md-form form-control" type="date"
                                    v-model="ind_dob" name="dob" v-validate="'required'" :max="maxDate18()" :min="minDate100()"
                                    :class="(ind_dob != '' && ind_dob != 'Invalid Date' ? 'active' : '') || { 'is-invalid': submittedRequest && errors.has('dob'), }"
                                    :disabled="disable" @input="checkGreaterAge('dateValidate')" />
                                <p class="error" v-if="submittedRequest" v-for="error in errors.collect('dob')">
                                    <!-- {{ error }} -->
                                    <span v-if="error == 'The dob must be in the format yyyy-MM-dd' || error.includes('required') || ind_dob == 'Invalid Date'">{{
                                        $t("fxDOBError")
                                    }}</span>
                                </p>
                                <p class="error" v-if="clientAge">{{ $t("step1_age_error") }}</p>
                                <p class="error" v-if="clientAge1">Invalid date. Age must be between 18 and 100 years.</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-12 mobPad mb-4">
                        <h3 class="greenlable">{{ $t("fxAddressDetails") }}</h3>
                        <div class="form-group field-wrapper">
                            <input class="float-field form-control" placeholder="" type="text" v-model="address1" v-validate="{ required: true, min:5 }"  name="Address Detail" :class="{'is-invalid': submittedRequest && errors.has('Address Detail'),}" :disabled="disable" />
                            <label class="float-label">{{$t ('fxEnterAddress')}} <sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('Address Detail')">{{error }}</p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mobPad mb-4">
                        <div class="form-group field-wrapper m-0">
                            <input placeholder=" " type="text" v-model="ind_city" class="float-field form-control" v-validate="'required'" name="city" :disabled="disable" />
                            <label class="float-label">{{ $t("fxCity") }} <sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('city')">
                                {{ error }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mobPad mb-4">
                        <div class="form-group field-wrapper m-0 tabClass">
                            <input placeholder=" " type="text" v-model="ind_residence_country" class="float-field form-control" name="residence country" :disabled="disable" readonly />
                            <label class="float-label">{{ $t('fxCountry') }}<sup class="red">*</sup></label>
                        </div>
                    </div>
                    <div class="col-12 mobPad mb-4">
                        <h3 class="subtitle mb-3 d-flex align-items-center greenlable">{{ $t('fxReportablePerson') }} 
                            <a href="#" class="ml-2 tooltip">
                            <div class='tooltiptext'>
                                <p>{{ $t('fxTooltip1') }}</p>
                                <ol type='I'>
                                <li>{{ $t('fxTooltip2') }}</li>
                                <li>{{ $t('fxTooltip3') }}</li>
                                <li>{{ $t('fxTooltip4') }}</li>
                                <li>{{ $t('fxTooltip5') }}</li>
                                <li>{{ $t('fxTooltip6') }}</li>
                                <li>{{ $t('fxTooltip7') }}</li>
                                <li>{{ $t('fxTooltip8') }}</li>
                                <li>{{ $t('fxTooltip9') }}</li>
                                </ol>  
                                <p>{{ $t('fxTooltip10') }} <a href='http://www.irs.gov/Businesses/Corporations/Foreign-Account-Tax-Compliance-Act-FATCA' target=_blank>{{ $t('fxTooltip11') }}</a></p>
                            </div>
                            <feather type="alert-circle"></feather>
                            </a>
                            <sup class="red">*</sup>
                        </h3>
                        <div class="d-flex align-items-center">
                            <label class="customRadio-button dot">{{ $t('fxYes') }}
                                <input type="radio" class="form-control" :value="1" v-model="usFatca"
                                    v-validate="'required'" name="usFatca" :checked="usFatca == 1"
                                    @change="usFatca = 1" :class="{ 'is-invalid': submitted && errors.has('usFatca') }">
                                <span class="checkmark"></span>
                            </label>
                            <label class="customRadio-button dot">{{ $t('fxNo') }}
                                <input type="radio" class="form-control" :value="0" v-model="usFatca"
                                    v-validate="'required'" name="usFatca" :checked="usFatca == 0" @change="usFatca = 0"
                                    :class="{ 'is-invalid': submitted && errors.has('usFatca') }">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <p class="error" v-if="submittedRequest && errors.has('usFatca')">
                            {{ errors.first('usFatca') }}
                        </p>
                        <div class="mb-2 mt-3" id="selectOption" v-if="(parseInt(usFatca) == 0)">
                            <h3><span class="greenlable"> {{ $t('fxTINNumber') }} </span> <sup class="red">*</sup></h3>
                            <div class="d-flex align-items-center mb-2">
                                <label class="customRadio-button  m-0 mr-2">{{ $t('fxYes') }}
                                    <input type="radio" class="form-control" :value="1" v-model="is_crs"
                                        @change="is_crs = 1" v-validate="'required'" name="CRS" :checked="is_crs == 1"
                                        :class="{ 'is-invalid': submitted && errors.has('CRS') }">
                                    <span class="checkmark"></span>
                                </label>
                                <label class="customRadio-button m-0">{{ $t('fxNo') }}
                                    <input type="radio" class="form-control" :value="0" v-model="is_crs"
                                        @change="is_crs = 0" v-validate="'required'" name="CRS" :checked="is_crs == 0"
                                        :class="{ 'is-invalid': submitted && errors.has('CRS') }">
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                            <p class="error" v-if="submittedRequest && errors.has('CRS')">
                                {{ errors.first('CRS') }}
                            </p>
                        </div>
                        <div class="form-group field-wrapper mb-2 mt-3 tabClass" v-if="is_crs == 1 && usFatca == 0">
                            <input type="text" v-model="crs" v-validate="'required'"
                                :class="{ 'is-invalid': submittedRequest && errors.has('TIN Number') }"
                                :disabled="disable" class="float-field form-control" name="TIN Number" />
                            <label class="float-label">{{ $t('fxEnterTINnumber') }}<sup class="red">*</sup></label>
                            <p class="error" v-for="error in errors.collect('TIN Number')"> {{ error }} </p>
                        </div>
                    </div>
                    <div class="col-12 mobPad">
                        <div
                            class="full-width pt-3 submitButton align-items-center d-flex justify-content-end mt-4 w-100">
                            <button class="prism_btn stepsBtn" v-on:click.prevent="submit()">
                                {{$t('fxSubmit')}}
                            </button>
                        </div>
                    </div>
                </div>
                <!--------------------------joint------------------------------->
                <div class="stepForm row" v-if="parseInt(get_user.account_type) == 1">
                    <h3 class="mb-3 w-100 pl-3">{{ $t("step1_firstmember") }}</h3>
                    <div class="col-12 col-md-4 mobPad">
                        <div class="form-group field-wrapper">
                            <input placeholder=" " type="text" v-model="joint_f_name_member1" v-validate="'required'"
                                name="Member 1 first name" class="float-field form-control" :class="{'is-invalid': submittedRequest && errors.has('Member 1 first name'),}" :disabled="disable" />
                            <label class="float-label">{{ $t("step1_fname") }}<sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest"
                                v-for="error in errors.collect('Member 1 first name')">
                                {{ error }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 mobPad">
                        <div class="form-group field-wrapper">
                            <input placeholder=" " type="text" v-model="joint_l_name_member1"
                                class="float-field form-control" v-validate="'required'" name="Member 1 last name"
                                :class="{'is-invalid': submittedRequest && errors.has('Member 1 last name'),}" :disabled="disable" />
                            <label class="float-label">{{ $t("step1_lname") }}<sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest"
                                v-for="error in errors.collect('Member 1 last name')">
                                {{ error }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 mobPad">
                        <div class="form-group field-wrapper">
                            <label class="Date_Birth">{{ $t("step1_dob") }}<sup class="red">*</sup></label>
                            <input class="customflaotField mdb-select md-form form-control" type="date"
                                v-model="joint_dob_member1" name="Member 1  Date Of Birth" v-validate="'required'"
                                :max="maxDate()" :class="(joint_dob_member1 != '' && joint_dob_member1 != 'Invalid Date' ? 'active' : '') || { 'is-invalid': submittedRequest &&  errors.has('Member 1  Date Of Birth'),}" :disabled="disable" @input="checkGreaterAge('joint')" 
                            />
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('Member 1  Date Of Birth')">
                                <span v-if="error.includes('required') || joint_dob_member1 == 'Invalid Date'">{{ $t("step1_member1dob") }}
                                </span>
                            </p>
                            <p class="error" v-if="clientAge">
                                {{ $t("step1_age_error") }}
                            </p>
                        </div>
                    </div>
                    <h3 class="mb-3 pl-3 w-100">{{ $t("step1_secondmember") }}</h3>
                    <div class="col-12 col-md-4 mobPad">
                        <div class="form-group field-wrapper">
                            <input placeholder=" " type="text" v-model="joint_f_name_member2" v-validate="'required'"
                                name="Member 2 first name" class="float-field form-control" :class="{'is-invalid': submittedRequest && errors.has('Member 2 first name'),}" :disabled="disable" />
                            <label class="float-label">{{ $t("step1_fname") }}<sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest"
                                v-for="error in errors.collect('Member 2 first name')">
                                {{ error }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 mobPad">
                        <div class="form-group field-wrapper">
                            <input placeholder=" " type="text" v-model="joint_l_name_member2"
                                class="float-field form-control" v-validate="'required'" name="Member 2 last name"
                                :class="{'is-invalid': submittedRequest && errors.has('Member 2 last name'), }" :disabled="disable" />
                            <label class="float-label">{{ $t("step1_lname") }}<sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest"
                                v-for="error in errors.collect('Member 2 last name')">
                                {{ error }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 mobPad">
                        <div class="form-group field-wrapper">
                            <label class="Date_Birth">{{ $t("step1_dob") }}<sup class="red">*</sup></label>
                            <input class="customflaotField mdb-select md-form form-control" type="date"
                                v-model="joint_dob_member2" name="Member 2  Date Of Birth" v-validate="'required'"
                                :max="maxDate()" :class="(joint_dob_member2 != '' && joint_dob_member2 != 'Invalid Date' ? 'active' : '') || {'is-invalid': submittedRequest && errors.has('Member 2  Date Of Birth'),}" :disabled="disable" @input="checkGreaterAge('joint')" 
                            />
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('Member 2  Date Of Birth')">
                                <span v-if="error.includes('required') || joint_dob_member2 == 'Invalid Date'">{{ $t("step1_menber2dobreq") }}</span>
                            </p>
                            <p class="error" v-if="clientAge2">
                                {{ $t("step1_age_error") }}
                            </p>
                        </div>
                    </div>
                    <h3 class="mb-3 w-100 pl-3">{{ $t("step1_adressinfo") }}</h3>
                    <div class="col-12 col-md-6 mobPad">
                        <div class="form-group field-wrapper">
                            <input placeholder=" " type="text" v-model="address1" class="float-field form-control"
                                v-validate="'required'" name="address1" :class="{'is-invalid': submittedRequest && errors.has('address1'),}" :disabled="disable" />
                            <label class="float-label">{{ $t("prof_addressLine1") }} <sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('address1')">
                                {{ error }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mobPad">
                        <div class="form-group field-wrapper m-0">
                            <input placeholder=" " type="text" class="float-field form-control" name="address2"
                                v-model="address2" :disabled="disable" />
                            <label class="float-label">{{$t("prof_addressLine2")}}</label>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mobPad mb-4">
                        <div class="form-group field-wrapper m-0">
                            <input placeholder=" " type="text" v-model="ind_city" class="float-field form-control"
                                v-validate="'required'" name="city" :class="{
                        'is-invalid': submittedRequest && errors.has('city'),}" :disabled="disable" />
                            <label class="float-label">{{ $t("step1_city") }}<sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('city')">
                                {{ error }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mobPad mb-4">
                        <div class="form-group field-wrapper m-0">
                            <input placeholder=" " type="text" v-model="ind_post_code" class="float-field form-control"
                                v-validate="{ required: true, min: 3, max: 12, numeric: true }" name="post code" :class="{
                        'is-invalid': submittedRequest && errors.has('post code'),
                    }" :disabled="disable" />
                            <label class="float-label">{{ $t("step1_postalcode") }}<sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('post code')">
                                {{ error }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mobPad mb-4">
                        <div class="form-group field-wrapper m-0 tabClass">
                            <input placeholder=" " type="text" v-model="ind_residence_country"
                                class="float-field form-control" name="residence country" :disabled="disable"
                                readonly />
                            <label class="float-label">{{ $t("step1_countryRes") }}<sup class="red">*</sup></label>
                        </div>
                    </div>
                    <h3 class="mb-3 w-100 pl-3">{{ $t("step1_addInfo") }}</h3>
                    <div class="col-12 col-md-6 mobPad">
                        <div class="form-group field-wrapper m-0 tabClass" v-on:click.prevent="tabActiveFun('2')">
                            <select class="customflaotField form-control" v-model="select_currency"
                                v-validate="'required'" name="currency" :class="(tabActive == '2' || select_currency != ''
                                    ? 'active'
                                    : '') || {
                                    'is-invalid':
                                        submittedRequest && errors.has('select_currency'),
                                }
                                " :disabled="disable">
                                <option v-for="(value, key) in $env_var.currency" :value="key">
                                    {{ key }}
                                </option>
                            </select>
                            <label class="float-label">{{ $t("step1_prefcurrency") }}<sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('currency')">
                                {{ error }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mobPad">
                        <div class="form-group field-wrapper">
                            <vue-phone-number-input v-model="mobile_no" :no-example="true"
                                :default-country-code="default_country" v-validate="{ required: true, min: 5, max: 15 }"
                                ref="mobile_numberInput" :class="{
                                    'is-invalid': submittedRequest && errors.has('phone_no'),
                                }" name="phone_no" @update="updatedText" />
                                <p class="error" v-for="error in errors.collect('phone_no')">
                                    <span v-show="submittedRequest &&
                                    error == 'The phone_no field is required.'
                                    ">{{ $t("step1_phnoRequired") }}</span>
                                            <span v-show="error ==
                                    'The phone_no field must be at least 8 characters.'
                                    ">{{ $t("step1_minimumph") }}</span>
                                            <span v-show="error ==
                                    'The phone_no field may not be greater than 15 characters.'
                                    ">{{ $t("step1_maxphone") }}</span>
                                </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-11 mobPad">
                        <div class="form-group field-wrapper mb-1 mt-2 custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="us_person" v-model="us_person"
                                :disabled="disable" />
                            <div class="Title d-flex align-items-center">
                                <p class="mb-0">{{ $t("step1_usPerson") }}</p>
                                <div class="tooltip">
                                    <span class="toolquestion">?</span>
                                    <span class="tooltiptext">
                                        <span class="inscroll scrollbar" v-html="$t('step1_stepMsz3')"></span>
                                    </span>
                                </div>
                            </div>
                            <label class="custom-control-label" for="us_person"
                                :class="us_person ? 'bold-yes' : 'bold-no'"><span class="yesno"></span>
                            </label>
                        </div>
                    </div>
                    <div class="col-12 mobPad">
                        <div
                            class="full-width border-top pt-3 submitButton align-items-center d-flex justify-content-end mt-3 w-100">
                            <button class="prism_btn btn_sm" v-on:click.prevent="submit()">
                                {{ $t("step1_Next") }}
                            </button>
                        </div>
                    </div>
                </div>

                <!--------------------------corporate------------------------------->
                <div class="stepForm row" v-if="parseInt(get_user.account_type) == 2">
                    <h3 class="mb-3 w-100 pl-3">{{ $t("step1_companyinfo") }}</h3>
                    <div class="col-12 col-md-6 mobPad">
                        <div class="form-group field-wrapper">
                            <input placeholder=" " type="text" v-model="cor_company_name"
                                class="float-field form-control" v-validate="'required'" name="Company Name" :class="{
                                    'is-invalid':
                                        submittedRequest && errors.has('Company Name'),
                                }" :disabled="disable" />
                            <label class="float-label">{{ $t("step1_companyname") }} <sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('Company Name')">
                                {{ error }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mobPad">
                        <div class="form-group field-wrapper">
                            <label class="Date_Birth">{{
                                $t("step1_incopDate")
                            }}</label>
                            <input class="customflaotField mdb-select md-form form-control" type="date"
                                v-model="cor_incor_date" name="incorporation date" v-validate="'required'"
                                :max="maxDate()" :class="(cor_incor_date != '' && cor_incor_date != 'Invalid Date'
                                    ? 'active'
                                    : '') || {
                                    'is-invalid':
                                        submittedRequest && errors.has('incorporation date'),
                                } " :disabled="disable" 
                            />
                            <p class="error" v-if="submittedRequest"
                                v-for="error in errors.collect('incorporation date')">
                                <span v-if="error.includes('required') ||
                                cor_incor_date == 'Invalid Date'
                                ">{{ $t("step1_incodateReq") }}</span>
                            </p>
                        </div>
                    </div>
                    <h3 class="mb-3 w-100 pl-3">{{ $t("step1_authorperson") }}</h3>
                    <div class="col-12 col-md-6 mobPad">
                        <div class="form-group field-wrapper">
                            <input placeholder=" " type="text" v-model="cor_f_name" v-validate="'required'"
                                name="first name1" class="float-field form-control" :class="{
                                    'is-invalid': submittedRequest && errors.has('first name1'),
                                }" :disabled="disable" />
                            <label class="float-label">{{ $t("step1_fname") }}<sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('first name1')">
                                {{ error.replace("first name1", "first name") }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mobPad">
                        <div class="form-group field-wrapper">
                            <input placeholder=" " type="text" v-model="cor_l_name" class="float-field form-control"
                                v-validate="'required'" name="last name1" :class="{
                                    'is-invalid': submittedRequest && errors.has('last name1'),
                                }" :disabled="disable" />
                            <label class="float-label">{{ $t("step1_lname") }}<sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('last name1')">
                                {{ error.replace("last name1", "last name") }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mobPad">
                        <div class="form-group field-wrapper">
                            <label class="Date_Birth">{{ $t("step1_dob") }}<sup class="red">*</sup></label>
                            <input class="customflaotField mdb-select md-form form-control" type="date"
                                v-model="cor_dob" name="dob" v-validate="'required'" :max="maxDate()" :class="(cor_dob != '' && cor_dob != 'Invalid Date'
                                    ? 'active'
                                    : '') || {
                                    'is-invalid': submittedRequest && errors.has('dob'),
                                }" :disabled="disable" @input="checkGreaterAge('corporate')" 
                            />
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('dob')">
                                <span v-if="error.includes('required') || cor_dob == 'Invalid Date'">{{ $t("step1_dobrequired") }}</span>
                            </p>
                            <p class="error" v-if="clientAge">
                                {{ $t("step1_age_error") }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mobPad">
                        <div class="form-group field-wrapper">
                            <vue-phone-number-input v-model="mobile_no" :no-example="true"
                                :default-country-code="default_country" v-validate="{ required: true, min: 5, max: 15 }"
                                ref="mobile_numberInput" :class="{
                                    'is-invalid': submittedRequest && errors.has('phone_no'),
                                }" name="phone_no" @update="updatedText" />
                            <!-- <label class="float-label">{{$t('step1_phno')}}<sup class="red">*</sup></label> -->
                            <p class="error" v-for="error in errors.collect('phone_no')">
                                <span v-show="submittedRequest &&
                                error == 'The phone_no field is required.'
                                ">{{ $t("step1_phnoRequired") }}</span>
                                <span v-show="error ==
                                'The phone_no field must be at least 8 characters.'
                                ">{{ $t("step1_minimumph") }}</span>
                                <span v-show="error ==
                                'The phone_no field may not be greater than 15 characters.'
                                ">{{ $t("step1_maxphone") }}</span>
                                <!-- <span v-else-if="error.includes('invalid')">{{$t('step1_correctno')}}</span> -->
                            </p>
                        </div>
                    </div>
                    <h3 class="mb-3 w-100 pl-3">{{ $t("step1_companyAdrsinfo") }}</h3>
                    <div class="col-12 col-md-6 mobPad">
                        <div class="form-group field-wrapper">
                            <input placeholder=" " type="text" v-model="address1" class="float-field form-control"
                                v-validate="'required'" name="address1" :class="{
                        'is-invalid': submittedRequest && errors.has('address1'),
                    }" :disabled="disable" />
                            <label class="float-label">{{ $t("step1_regAddone") }} <sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('address1')">
                                {{ error }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mobPad">
                        <div class="form-group field-wrapper m-0">
                            <input placeholder=" " type="text" class="float-field form-control" name="address2"
                                v-model="address2" :disabled="disable" />
                            <label class="float-label">{{
                        $t("step1_regAddtwo")
                    }}</label>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mobPad mb-4">
                        <div class="form-group field-wrapper m-0">
                            <input placeholder=" " type="text" v-model="ind_city" class="float-field form-control"
                                v-validate="'required'" name="city" :class="{
                        'is-invalid': submittedRequest && errors.has('city'),
                    }" :disabled="disable" />
                            <label class="float-label">{{ $t("step1_city") }}<sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('city')">
                                {{ error }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mobPad mb-4">
                        <div class="form-group field-wrapper m-0">
                            <input placeholder=" " type="text" v-model="ind_post_code" class="float-field form-control"
                                v-validate="{ required: true, min: 3, max: 12, numeric: true }" name="post code" :class="{
                        'is-invalid': submittedRequest && errors.has('post code'),
                    }" :disabled="disable" />
                            <label class="float-label">{{ $t("step1_postalcode") }}<sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('post code')">
                                {{ error }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mobPad mb-4">
                        <div class="form-group field-wrapper m-0 tabClass">
                            <input placeholder=" " type="text" v-model="ind_residence_country"
                                class="float-field form-control" name="residence country" :disabled="disable"
                                readonly />
                            <label class="float-label">{{ $t("step1_country") }} <sup class="red">*</sup></label>
                        </div>
                    </div>
                    <h3 class="mb-3 w-100 pl-3">{{ $t("step1_addInfo") }}</h3>
                    <div class="col-12 col-md-6 mobPad">
                        <div class="form-group field-wrapper m-0 tabClass" v-on:click.prevent="tabActiveFun('2')">
                            <select class="customflaotField form-control" v-model="select_currency"
                                v-validate="'required'" name="currency" :class="(tabActive == '2' || select_currency != ''
                        ? 'active'
                        : '') || {
                        'is-invalid':
                            submittedRequest && errors.has('select_currency'),
                    }
                        " :disabled="disable">
                                <option v-for="(value, key) in $env_var.currency" :value="key">
                                    {{ key }}
                                </option>
                            </select>
                            <label class="float-label">{{ $t("step1_prefcurrency") }}<sup class="red">*</sup></label>
                            <p class="error" v-if="submittedRequest" v-for="error in errors.collect('currency')">
                                {{ error }}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-11 mobPad">
                        <div class="form-group field-wrapper mb-1 mt-2 custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" id="us_person" v-model="us_person"
                                :disabled="disable" />
                            <div class="Title d-flex align-items-center">
                                <p class="mb-0">{{ $t("step1_usPerson") }}</p>
                                <div class="tooltip">
                                    <span class="toolquestion">?</span>
                                    <span class="tooltiptext">
                                        <span class="inscroll scrollbar" v-html="$t('step1_stepMsz3')"></span>
                                    </span>
                                </div>
                            </div>
                            <label class="custom-control-label" for="us_person"
                                :class="us_person ? 'bold-yes' : 'bold-no'"><span class="yesno"></span>
                            </label>
                        </div>
                    </div>
                    <div class="col-12 mobPad">
                        <div
                            class="full-width border-top pt-3 submitButton align-items-center d-flex justify-content-end mt-3 w-100">
                            <button class="prism_btn btn_sm" v-on:click.prevent="submit()">
                                {{ $t("step1_Next") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Datepicker from "vue2-datepicker";
import * as types from "@/types";
import { mapActions } from "vuex";
import moment from "moment";
export default {
    name: "stepOne",
    data() {
        return {
            residence_country: [],
            ind_f_name: "",
            ind_l_name: "",
            ind_residence_country: "",
            ind_post_code: "",
            ind_city: "",
            ind_pep: false,
            ind_dob: null,

            joint_f_name_member1: "",
            joint_l_name_member1: "",
            joint_dob_member1: "",
            joint_f_name_member2: "",
            joint_l_name_member2: "",
            joint_dob_member2: "",

            cor_incor_date: "",
            cor_company_name: "",
            cor_dob: "",
            cor_f_name: "",
            cor_l_name: "",

            phone_no: "",
            mobile_number: "",
            mobile_no: '',
            userCountry: "N/A",
            numberWithCountry: "",
            numberValid: true,
            address1: "",
            us_person: false,
            default_country: "",

            step: "1",
            disabledDates: {
                from: new Date().setDate(new Date().getDate() - 18250),
                to: new Date().setDate(new Date().getDate() - 4850),
            },
            lang: {
                formatLocale: {
                    firstDayOfWeek: 1,
                },
                monthBeforeYear: false,
            },
            tabActive: "",
            pageLoader: false,
            msg_type: "",
            response_msg: "",
            submittedRequest: false,
            disable: false,
            // isDisabled: false,
            select_currency: "",
            select_country: "",
            select_month: "",
            select_day: "",
            select_year: "",
            jurisdiction_tax_residence: "",
            address2: "",
            age18Greater: moment(
                new Date().setTime(
                    Date.now().valueOf() - 18 * 365 * 24 * 60 * 60 * 1000
                )
            ).format("YYYY-MM-DD"),
            currentDate: moment(new Date()).format("YYYY-MM-DD"),

            clientAge: false,
            clientAge2: false,
            clientAge1: false,

            usFatca: '',
            // tax_residency: '',
            is_crs: null,
            crs_reason: '',
            crs: '',
            submitted: false,
            date: '',
            month: '',
            year: '',
            individual_date: '',
        };
    },
    computed: {
        checkdob() {
            if(this.date == '' || this.month =='' || this.year==''){
                return;
            }
        }
    },
    methods: {
        checkGreaterAge(getData) {
            const dateB = moment();
            if (getData == "dateValidate") {
                let member1 = this.ind_dob
                if (member1 != "" && member1 != null && member1 != "Invalid Date") {
                    const ind_dob = moment(member1).format("YYYY-MM-DD");
                    const age = dateB.diff(ind_dob, "years");

                    if (age < 18 || age > 100) {
                        this.clientAge1 = true;
                    }else{
                        this.clientAge1 = false;
                    }
                }
            }else  if (getData == "joint") {
                if (
                    this.joint_dob_member1 != "" &&
                    this.joint_dob_member1 != null &&
                    this.joint_dob_member1 != "Invalid Date"
                ) {
                    const dateOfMember1 = moment(this.joint_dob_member1).format(
                        "YYYY-MM-DD"
                    );
                    const ageDifferenceOfMember1 = dateB.diff(dateOfMember1, "years");
                    if (ageDifferenceOfMember1 >= 18 && ageDifferenceOfMember1 <= 80) {
                        this.clientAge = false;
                    } else {
                        this.clientAge = true;
                    }
                }

                if (
                    this.joint_dob_member2 != "" &&
                    this.joint_dob_member2 != null &&
                    this.joint_dob_member2 != "Invalid Date"
                ) {
                    const dateOfMember2 = moment(this.joint_dob_member2).format(
                        "YYYY-MM-DD"
                    );
                    const ageDifferenceOfMember2 = dateB.diff(dateOfMember2, "years");
                    if (ageDifferenceOfMember2 >= 18 && ageDifferenceOfMember2 <= 80) {
                        this.clientAge2 = false;
                    } else {
                        this.clientAge2 = true;
                    }
                }
            } else {
                let member1 = getData == "corporate" ? this.cor_dob : this.ind_dob;
                if (member1 != "" && member1 != null && member1 != "Invalid Date") {
                    const dateC = moment(member1).format("YYYY-MM-DD");
                    const age = dateB.diff(dateC, "years");
                    this.clientAge2 = false;
                    console.log('age', age)
                    if (age >= 18) {
                        console.log('1')
                        this.clientAge = false;
                    } else {
                        console.log('2')
                        this.clientAge = true;
                    }
                }
            }
        },
        updatedText(e) {
            this.numberWithCountry = e.formattedNumber;
            this.numberValid = e.isValid;
        },
        maxDate() {
            return moment().format("YYYY-MM-DD");
        },
        maxDate18() {
            // return moment().format("YYYY-MM-DD");
            const today = new Date();
            today.setFullYear(today.getFullYear() - 18); // go back 18 years
            return today.toISOString().split("T")[0];   // format YYYY-MM-DD
        },
        minDate100() {
            // Earliest allowed DOB (today - 100 years)
            const today = new Date();
            today.setFullYear(today.getFullYear() - 100);
            return today.toISOString().split("T")[0];
        },
        countryFunc() {
            let count = 0;
            for (var key in this.countriesList) {
                count++;
                if (this.countriesList[key].iso2 == this.get_user.country) {
                    this.ind_residence_country = this.countriesList[key].name;
                }
            }
        },
        tabActiveFun(getData) {
            this.tabActive = getData;
        },
        customFormatter(date) {
            return moment(date).format("DD-MM-YYYY");
        },
        ...mapActions({
            _runRegisterStepOne: types.RUN_REGISTER_STEP1,
            _runGetUserIp: types.RUN_GET_USER_IP,
        }),
        submit() {
            if (this.disable) {
                tax_residency
                this.$router.replace("/step2");
            } else {
                const _that = this;
                this.submittedRequest = true;
                this.$validator.validate().then((valid) => {
                    if (valid && !_that.clientAge && !_that.clientAge2 && !_that.clientAge1) {
                        let input_json = {
                            globalParams: {
                                account_type: _that.get_user.account_type,
                                // dob: _that.individual_date,
                                address1: _that.address1,
                                city: _that.ind_city,
                                residence_country: _that.get_user.country,
                                usFatca: parseInt(_that.usFatca),
                                is_crs: _that.is_crs,
                                step: _that.step,
                                ip_country: _that.userCountry,
                                pep: null,
                                currency: "",
                                mobile_no: "",
                                fname: "",
                                lname: "",
                            },
                            localParams: { parameter: _that, step: _that.step },
                        };
                        if (parseInt(_that.get_user.account_type) == 0) {
                            input_json.globalParams.fname = _that.ind_f_name;
                            input_json.globalParams.lname = _that.ind_l_name;

                            input_json.globalParams.pep = _that.ind_pep;
                            input_json.globalParams.dob = moment(_that.ind_dob).format(
                                "YYYY-MM-DD"
                            );
                            input_json.globalParams.currency = _that.select_currency;
                            input_json.globalParams.mobile_no = _that.numberWithCountry;

                        } else if (parseInt(_that.get_user.account_type) == 1) {
                            input_json.globalParams.fname = _that.joint_f_name_member1;
                            input_json.globalParams.lname = _that.joint_l_name_member1;
                            input_json.globalParams.dob = moment(
                                _that.joint_dob_member1
                            ).format("YYYY-MM-DD");
                            input_json.globalParams.member_fname = _that.joint_f_name_member2;
                            input_json.globalParams.member_lname = _that.joint_l_name_member2;
                            input_json.globalParams.member_dob = moment(
                                _that.joint_dob_member2
                            ).format("YYYY-MM-DD");
                            input_json.globalParams.currency = _that.select_currency;
                        } else if (parseInt(_that.get_user.account_type) == 2) {
                            input_json.globalParams.fname = _that.cor_f_name;
                            input_json.globalParams.lname = _that.cor_l_name;
                            input_json.globalParams.incorporation_date = _that.cor_incor_date;
                            input_json.globalParams.company_name = _that.cor_company_name;
                            input_json.globalParams.dob = moment(_that.cor_dob).format(
                                "YYYY-MM-DD"
                            );
                            input_json.globalParams.currency = _that.select_currency;
                        }
                        if (_that.usFatca == 0 && _that.is_crs == 1) {
                            input_json.globalParams.crs = _that.crs;
                        }
                        _that._runRegisterStepOne(input_json);
                    } else {
                        console.log("_that.errors", _that.errors)
                        _that.handleValidationErrorAdvanced(_that.errors);
                    }
                });
            }
        },
    },
    components: {
        datepicker: Datepicker,
    },
    created() {
        const _that = this;
        try {
            this._runGetCountriesList({
                globalParams: {},
                localParams: { parameter: this, page: "register" },
            });
        } catch (error) {
            console.log(error)
        }
        this._runGetUserRegisterationStepData({
            globalParams: {},
            localParams: { parameter: this, step: this.step, tab: 1 },
        });
        window.setTimeout(_that._runGetUserRegisterationStepData({'globalParams' :{},'localParams' :{ "parameter" : _that , "step" : '1'}}), 5000)

        this._runGetUserIp({ globalParams: {}, localParams: { parameter: this } });
    },
    mounted() {
        const _that = this;
        $(document).on("click", function (event) {
            if (!$(event.target).closest(".tabClass").length) {
                _that.tabActive = "";
            }
        });
    },
};
</script>
<style type="scoped">
/* custom tooltip css  */
.cstm-tooltip {
    padding: 10px;
}

.cstm-tooltip p {
    color: #fff;
    text-align: left !important;
    margin-bottom: 5px;
}

.cstm-tooltip ol {
    list-style: upper-roman;
    padding-left: 20px;
}

.cstm-tooltip ol li {
    color: #fff;
    text-align: left !important;
    margin-bottom: 5px;
}

.tooltip {
    z-index: 9999;
}

.tooltip-inner {
    max-width: 400px;
    padding: 3px 8px;
    color: #fff;
    text-align: left !important;
    width: 100%;
    z-index: 999999;
    background-color: #000;
}

.tooltip .tooltiptext {
    padding: 10px;
    background-color: #000;
    color: #fff;
    position: absolute;
    top: -200px;
    left: -318px;
}

.tooltip .tooltiptext p {
    color: #fff;
    text-align: left !important;
    margin-bottom: 5px;
}

.tooltiptext ol {
    list-style-type: upper-roman;
    margin: 15px 0 0 0;
    padding: 4px;
}

.tooltiptext ol li {
    margin-left: 20px;
    text-align: left !important;
    line-height: 22px;
    margin-bottom: 5px;
}

.tooltip .tooltiptext::after {
    border-color: #000 transparent transparent transparent;
    top: 97%;
    left: 195px;
    transform: rotate(135deg);
    border-top: 11px solid #000;
    border-right: 8px solid #000;
}
</style>


// WEBPACK FOOTER //
// src/components/fxView/registerSteps/step1.vue